import EditLocation from './EditLocation.container';

export default EditLocation;
